const bxfCalendar = {
    svg: '<svg style="width:1rem; height:0.875rem;" viewBox="0 0 16 14"><path d="M4.625 0v1.75H2v2.625h12.25V1.75h-2.625V0h-1.75v1.75h-3.5V0zm9.625 5.25H2V14h12.25z"/></svg>',
};

export { bxfCalendar as default };
